import React from 'react';
//import PropTypes from 'prop-types';

import {
  Button,
  Divider,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Radio
} from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';

import * as api from '_core/utils/api';
import * as hooks from '_core/utils/hooks';
import { useVisitorInfo } from '_core/utils/visitorInfo';
import { withLang } from '_core/hocs/withLang';
import { useCartContext } from '_core/contexts/Cart';
import { Flex } from '_core/components/Flex';
import { ModalInner } from '_core/components/ModalInner';
import { ModalOuter } from '_core/components/ModalOuter';

import { useStyle } from './style';


const getClientVisitor = async (visitorId, query) => {
  const token = await api.getClientTokenGenerate(visitorId);
  
  const result = await api.getClientVisitor({ token, query, limit: 5 });
  
  if (!result.length)
    return null;
  
  return result;
};


export const RawGoodsCartGroupOrderModal = (props) => {
  const {
    getLangString: l
  } = props;
  
  
  const classes = useStyle();
  
  const visitorInfo = useVisitorInfo();
  const cart = useCartContext();
  
  const [search, setSearch] = React.useState('');
  const [searchUsers, setSearchUsers] = React.useState();
  const [searchUserSelected, setSearchUserSelected] = React.useState();
  const [visitorSelected, setVisitorSelected] = React.useState();
  
  
  const visitorId = visitorInfo.info?.id;
  
  React.useEffect(() => {
    if (!visitorId)
      return;
    
    if (!visitorSelected)
      setVisitorSelected(visitorInfo.info);
  }, [visitorId]);
  
  hooks.useTimeoutEffect(() => {
    if (!search) {
      if (searchUsers)
        setSearchUsers(null);
      
      return;
    }
    
    setSearchUsers(null);
    setSearchUserSelected(null);
    
    getClientVisitor(visitorId, search)
      .then((result) => setSearchUsers(result))
      .catch((error) => { console.error(error); setSearchUsers(null); });
  }, [visitorId, search], 200);
  
  
  return (
    <ModalOuter open={cart.isGroupOrderModalVisible} fullWidth={true} maxWidth="md" onClose={() => cart.setGroupOrderModalVisible(false)}>
      <ModalInner
        className={classes.content}
        title={l('$r._.select.user')}
        content={
          <Flex flexDirection="column" gap={2}>
            <FormControl fullWidth variant="outlined">
              <InputLabel htmlFor="user-search-input">{l('$r.poisk')}</InputLabel>
              <OutlinedInput
                type="text"
                id="user-search-input"
                className={classes.searchInput}
                value={search}
                onChange={(event) => setSearch(event.target.value)}
                label={l('$r.poisk')}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      className={classes.searchButton}
                      edge="end"
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            
            {searchUsers ? (
              <Flex flexDirection="column" gap={1}>
                {searchUsers.map((user, index) => (
                  <>
                    {index ? (<Divider />) : null}
                    
                    <Flex
                      className={classes.userItem}
                      flexDirection="row"
                      alignItems="center"
                      gap={2}
                      onClick={() => setSearchUserSelected(user)}
                    >
                      <Radio checked={user === searchUserSelected} />
                      
                      <div>{user.login}</div>
                    </Flex>
                  </>
                ))}
              </Flex>
            ) : null}
          </Flex>
        }
        actions={
          <>
            &nbsp;
            
            <Button
              disabled={!searchUserSelected}
              onClick={() => {
                if (searchUserSelected)
                  cart.addGroupOrderTarget(searchUserSelected);
                
                cart.setGroupOrderModalVisible(false);
              }}
            >
              {l('$global.buttons.confirm')}
            </Button>
          </>
        }
      />
    </ModalOuter>
  );
};

RawGoodsCartGroupOrderModal.defaultProps = {};

RawGoodsCartGroupOrderModal.propTypes = {
};

export default withLang(RawGoodsCartGroupOrderModal);
